import { createTheme, createVariant, globalTheme } from '@cld/component-theme';
import { ChipProps } from './Chip';

const { palette, spacing, radius } = globalTheme;

export const theme = createTheme({
  background: {
    color: palette.secondary,
    contrast: palette.contrastHigh,
  },
  list: {
    spacing: spacing.xxs,
  },
  radius: radius.xl,
  rightSlotSpacing: spacing.xs,
  leftSlotSpacing: spacing.xxs,
  // sizes
  md: {
    padding: {
      vertical: spacing.xxs,
      horizontal: spacing.xs,
    },
  },
  sm: {
    padding: {
      vertical: '0.188rem',
      horizontal: spacing.xs,
    },
  },

  selectable: {
    border: {
      width: '1px',
      color: palette.secondary,
    },
    background: {
      color: {
        unselected: palette.surface,
      }
    }
  }
});

type ThemeProps = Required<Pick<ChipProps, 'size'>>;

export const sizeVariant = createVariant(({ size }: ThemeProps) => theme[size]);
